import { ArcSkeleton, ArcStack } from '@src/core/ui';
import React from 'react';

const SidebarLoading: React.FC = () => {
  return (
    <ArcStack spacing={2}>
      <ArcSkeleton width={200} height={20} />
      <ArcSkeleton width='100%' height={45} />
      <ArcSkeleton width='100%' height={45} />
      <ArcSkeleton width='100%' height={45} />
      <ArcSkeleton width='100%' height={45} />
      <ArcStack spacing={1}>
        <ArcSkeleton width={150} height={20} />
        <ArcSkeleton width='100%' height={45} />
      </ArcStack>
    </ArcStack>
  );
};

export default SidebarLoading;